<template>
    <video ref="videoPlayer" class="video-js vjs-big-play-centered vjs-16-9"></video>
</template>

<script>
import videojs from 'video.js';
import "videojs-mux";

export default {
  name: "VideoPlayer",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      player: null
    }
  },
  mounted() {
    this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {
      //do nothing
    })
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>